const PAYMENT_FAILURE_PATTERN = /(131042|unsettled payments|payment issue|cobrança pendente)/i;

export const hasRouteDispatchFailure = (route) => (
  Number(route?.total_grupos_falha || 0) > 0
  || (Array.isArray(route?.envios_grupos)
    && route.envios_grupos.some((envio) => envio?.status === "falha"))
);

export const formatRouteDispatchFailureMessage = (value) => {
  const routeMessage = value && typeof value === "object"
    ? value.ultimo_erro_envio
      || value.erro_mensagem
      || value.envios_grupos?.find((envio) => envio?.status === "falha")?.erro_mensagem
    : value;
  const raw = String(routeMessage || "").trim();

  if (PAYMENT_FAILURE_PATTERN.test(raw)) {
    return "A Meta bloqueou os envios porque havia uma cobrança pendente no WhatsApp Business. Depois de regularizar em WhatsApp Manager > Cobrança, clique em “Tentar envio novamente”.";
  }
  if (/not_ready|não está pronta/i.test(raw)) {
    return "A integração da Meta ainda não estava pronta para este envio. Confira a configuração do WhatsApp e tente novamente.";
  }
  if (/^A Meta /i.test(raw)) return raw;
  if (raw) return `Não foi possível concluir o envio pela Meta. Detalhe: ${raw}`;
  return "Não foi possível concluir o envio pela Meta. Abra a van para ver o grupo afetado e tentar novamente.";
};
